import AddPage from "../pages/page/addPage";
import EditPage from "../pages/page/editPage";
import PageIndex from "../pages/page/page";

const pageRoutes = [
  {
    path: "pages",
    element: <PageIndex />,
  },
  {
    path: "pages/add",
    element: <AddPage />,
  },
  {
    path: "pages/edit/:id",
    element: <EditPage />,
  },
];

export default pageRoutes;